import React from 'react';
import { useContent } from '../../../hooks/useContent';
import { conferenceEn } from '../../../content/conferenceEn';
import styles from './ConferenceAccommodation.module.css';

const OPTION_IDS = ['opt1', 'opt2', 'opt3'];
const POINT_KEYS = ['p1', 'p2', 'p3'];

const ConferenceAccommodation = () => {
  const { t } = useContent();
  const def = conferenceEn.accommodation;

  const optionPoints = (optId) => {
    const o = def[optId] || {};
    return POINT_KEYS.map((pk) => t(`conferenceAccommodation.${optId}.${pk}`, o[pk] ?? '')).filter((x) =>
      String(x).trim(),
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.textBlock}>
          <h1 className={styles.title}>{t('conferenceAccommodation.title', def.title)}</h1>
          <p className={styles.subtitle}>{t('conferenceAccommodation.subtitle', def.subtitle)}</p>
        </div>
        <div className={styles.imageBlock} />
      </div>
      <div className={styles.optionsGrid}>
        {OPTION_IDS.map((optId, idx) => {
          const o = def[optId] || {};
          const num = idx + 1;
          const title = t(`conferenceAccommodation.${optId}.title`, o.title ?? '');
          const badge = t(`conferenceAccommodation.${optId}.badge`, o.badge ?? '');
          const points = optionPoints(optId);
          const prefix = t('conferenceAccommodation.optionPrefix', def.optionPrefix);
          return (
            <div key={optId} className={styles.optionCard}>
              <div className={styles.optionNumber}>
                {prefix} {num}
              </div>
              <h3 className={styles.optionTitle}>{title}</h3>
              {String(badge).trim() ? <span className={styles.badge}>{badge}</span> : null}
              <ul className={styles.pointsList}>
                {points.map((point, i) => (
                  <li key={`${optId}-${i}`} className={styles.point}>
                    <span className={styles.bullet}>•</span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>

      <div className={styles.infoBox}>
        <h3 className={styles.infoTitle}>{t('conferenceAccommodation.infoTitle', def.infoTitle)}</h3>
        <ul className={styles.infoList}>
          <li className={styles.infoItem}>
            <span className={styles.infoBullet}>•</span>
            {t('conferenceAccommodation.infoLi1', def.infoLi1)}
          </li>
          <li className={styles.infoItem}>
            <span className={styles.infoBullet}>•</span>
            {t('conferenceAccommodation.infoLi2', def.infoLi2)}
          </li>
        </ul>
      </div>

      <div className={styles.mapContainer}>
        <div className={styles.mapPin}>
          <div className={styles.mapPinInner} />
        </div>
        <div className={styles.mapLabel}>{t('conferenceAccommodation.mapLabel', def.mapLabel)}</div>
      </div>
    </div>
  );
};

export default ConferenceAccommodation;
